import { InphiniteThemeBaseColors } from '@facephi/ui-react';

export const RoutesName = {
  users: '/users',
  userDetail: '/users/:id',
};

export const OPERATIONS_COLORS: { [key in string]: InphiniteThemeBaseColors } =
  {
    teseo: 'grey',
    onboarding: 'purple',
    authentication: 'blue',
    'Rectification of record': 'warning',
    'Deletion of record': 'error',
    'Record information': 'blue',
  };

export const CREDENTIALS_STATE = {
  Active: 'Active',
  Expired: 'Expired',
};

export const ZOOM = {
  minZoom: 0.25,
  maxZoom: 1,
  defaultScale: 0.25,
  defaultZoom: 1,
};
export const MAX_ITEMS_PAGE = 20;
